import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
// import { requestChangePassword } from '../../store/user/user.thunks'
import {setReq} from '../../store/deposit/deposit.slice'

export const connectDeposit = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      user: state.user,
      elementsParams: state.elementsParams
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      setReq
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
